import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export function ApprovalBlockersPanel({ blockers }: { blockers: string[] }) {
  if (blockers.length === 0) return null;

  return (
    <Alert severity="warning">
      <AlertTitle>Launch approval blocked</AlertTitle>
      <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
        {blockers.map((blocker) => (
          <Typography component="li" variant="body2" key={blocker}>
            {blocker}
          </Typography>
        ))}
      </Box>
    </Alert>
  );
}
